import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../data/checkLottie.json'
import { colors } from '../color';

const ConfirmationScreen = () => {

  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
  <Lottie options={defaultOptions} height={300} width={300} style={{marginTop:'40px'}} />

  <h1 style={{ margin: '20px', marginTop:'70px', fontWeight: 700, fontFamily:'Inter', color: colors.green }}>
    Félicitations !
  </h1>
  <p style={{ margin: '25px', textAlign: 'center', fontWeight: 400, fontFamily:'Inter', color: colors.green, fontSize: '15px', }}>
    Votre adresse a été confirmée avec succès. Vous pouvez maintenant revenir à l'application.
  </p>
</div>

  );
};

export default ConfirmationScreen;
